import React, { FC, useEffect, lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { Layout } from 'components/Layout';
import { RoutePaths } from './RoutePaths';
import { LoadingPage } from 'components/common/Loading';
import { ProtectedRoute } from './ProtectedRoute';
import { Permissions } from 'services/RightsService';

const Subscriptions = lazy(() => import('components/pages/Subscriptions/SubscriptionsLayout'));
const History = lazy(() => import('components/pages/History/HistoryLayout'));

const NotAuthorized = lazy(() => import('components/pages/Errors/NotAuthorized'));
const NotFound = lazy(() => import('components/pages/Errors/NotFound'));

export const AppRoutes: FC = () => {
    useEffect(() => {
        if (window.location.href.includes('#') && !window.location.href.includes('/#access_token')) {
            window.location.href = window.location.href
                .replace(/\/#\//, '/')
                .replace(/\/#/, '/');
        }
    });

    return <Layout>
        <Suspense fallback={<LoadingPage />}>
            <Routes>
                <Route path={RoutePaths.Subscriptions.AllActive.route}
                    element={<ProtectedRoute permissionsForOtherProfile={[Permissions.MANAGE_CONTACT_SUBSCRIPTIONS]}><Subscriptions /></ProtectedRoute>} />

                <Route path={RoutePaths.Subscriptions.Manage.route}
                    element={<ProtectedRoute permissionsForOtherProfile={[Permissions.MANAGE_CONTACT_SUBSCRIPTIONS]}><Subscriptions /></ProtectedRoute>} />

                <Route path={RoutePaths.History.route}
                    element={<ProtectedRoute permissionsForOtherProfile={[Permissions.MANAGE_CONTACT_SUBSCRIPTIONS]}><History /></ProtectedRoute>} />

                <Route path={RoutePaths.Errors.NotAuthorized.route}
                    element={<NotAuthorized />} />

                <Route path={RoutePaths.Errors.NotFound.route}
                    element={<NotFound />} />
            </Routes>
        </Suspense>
    </Layout>;
};
